import { Component } from 'react';
import { concat, from } from 'rxjs';

import { IOC_TYPES } from '../../../context/ioc.types';
import { lazyInject } from '../../../context/module';
import { ScriptLoadService } from '../../../services/script-load.service';
import { untilDestroyed } from '../../../utils/until-destroyed';
import styles from './product-page.component.module.scss';

export default class ProductPageComponent extends Component {

    @lazyInject(ScriptLoadService) private scriptLoader: ScriptLoadService;

    constructor(props) {
        super(props);
    }

    componentDidMount() {
        concat(
            from(this.scriptLoader.loadAllScriptsIfNotLoaded(true)),
            from(this.scriptLoader.loadStripe()),
            from(ScriptLoadService.loadPayPal()),
        ).pipe(
            untilDestroyed(this),
        ).subscribe({
            next: () => {
                // skip
            }
        });
        // TODO Preact fix
        // this.renderer.addClass(this.document.body, 'product-page');
    }

    componentWillUnmount() {
        // TODO Preact fix
        // this.renderer.removeClass(this.document.body, 'product-page');
    }

    render() {
        return <div className="container-fluid p-0"> {/* Remove default padding */}
            <div className={`${styles['product-page']}`}>
                <div className={styles['hero']}>
                    <div className={styles['hero-badge']}>UNLIMITED</div>
                    <h1 className={styles['hero-title']}>
                        Do more with your files.<br/>
                        <span className={styles['hero-gradient']}>Without limits.</span>
                    </h1>
                    <p className={styles['hero-subtitle']}>
                        Faster uploads, higher compression, priority processing, and 4 GB file support — all with one plan.
                    </p>
                </div>

                {/* Hero Illustration */}
                <div className={`container ${styles['content-section']}`}>
                    <div className={styles['display-image']}>
                        <img className={styles['frame']} src="/img/xconvert/hero-conversion.svg" alt="File conversion illustration - Convert, compress and merge files" />
                    </div>
                </div>


                {/* Features Section */}
                <div className={`container mt-5 pt-5 ${styles["content-section"]}`}>
                    <div className="text-center mb-5">
                        <div className={styles['section-icon']}>⚡</div>
                        <h2 className={styles['section-title']}>A Powerful Online Solution</h2>
                        <p className={styles['section-subtitle']}>
                            The best tool to convert, compress, merge and split document and media files.
                        </p>
                    </div>

                    <div className="row">
                        <div className="col-md-6 mb-4">
                            <div className={styles['feature-card']}>
                                <div className={styles['feature-icon']}>🎯</div>
                                <h4 className={styles['feature-title']}>Higher Compression</h4>
                                <p className={styles['feature-text']}>
                                    Unlock advanced encoders like HEVC and VP9 for video, and specialized compression for TIFF and PDF.
                                    Achieve up to 50% better compression while preserving quality.
                                </p>
                            </div>
                        </div>
                        <div className="col-md-6 mb-4">
                            <div className={styles['feature-card']}>
                                <div className={styles['feature-icon']}>♾️</div>
                                <h4 className={styles['feature-title']}>More Storage and Time</h4>
                                <p className={styles['feature-text']}>
                                    Extended processing time per task and immediate priority.
                                    Basic users get 1 GB, Pro users get a massive 4 GB file size limit.
                                </p>
                            </div>
                        </div>
                        <div className="col-md-6 mb-4">
                            <div className={styles['feature-card']}>
                                <div className={styles['feature-icon']}>🔒</div>
                                <h4 className={styles['feature-title']}>Priority Processing</h4>
                                <p className={styles['feature-text']}>
                                    Subscribers get full priority access to our processing power.
                                    With dedicated CPU time, your tasks complete significantly faster.
                                </p>
                            </div>
                        </div>
                        <div className="col-md-6 mb-4">
                            <div className={styles['feature-card']}>
                                <div className={styles['feature-icon']}>🚀</div>
                                <h4 className={styles['feature-title']}>Faster File Uploading</h4>
                                <p className={styles['feature-text']}>
                                    Your files upload in parallel chunks to the closest server in our
                                    global edge network — so even large files transfer quickly, and
                                    uploads resume automatically if your connection drops.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Pricing Section */}
                <div className={`container mt-5 pt-4 ${styles["content-section"]}`}>
                    <div className="text-center mb-4">
                        <h2 className={styles['section-title']}>Simple, transparent pricing</h2>
                        <p className={styles['section-subtitle']}>
                            Choose the plan that fits your needs. Cancel anytime.
                            <br />Just visiting? Everyone gets 30 free video conversions a day — 60 with a free account.
                        </p>
                    </div>
                    <div className={styles['packages']}>
                        <div className={styles['package-container']}>
                            <div className={styles['package']}>
                                <h4>Basic</h4>
                                <div className={styles['pricing-display']}>
                                    <span className={styles['price-large']}>$4.99</span>
                                    <span className={styles['price-sub']}>per month</span>
                                    <span className={styles['price-annual']}>or $49.99 billed yearly</span>
                                </div>
                                <ul>
                                    <li className={styles['check']}><b>No ads — nothing between you and your file</b></li>
                                    <li className={styles['check']}>1 GB file size limit</li>
                                    <li className={styles['check']}>4 hr/task process time</li>
                                    <li className={styles['check']}>10 Concurrent non-video tasks</li>
                                    <li className={styles['check']}>4 Concurrent video tasks</li>
                                    <li className={styles['check']}>200 video conversions per day</li>
                                    <li className={styles['check']}>8 hours of processing time per day**</li>
                                    <li className={styles['check']}>Advanced encoders</li>
                                </ul>
                                <a className={`${styles['btn']} ${styles['btn-outline']}`} href="/product/backer_monthly">
                                    Start Basic
                                </a>
                            </div>
                        </div>
                        <div className={styles['package-container']}>
                            <div className={`${styles['package']} ${styles['has-badge']}`}>
                                <div className={styles['recommended-badge']}>Recommended</div>
                                <h4>Pro</h4>
                                <div className={styles['pricing-display']}>
                                    <span className={styles['price-large']}>$9.99</span>
                                    <span className={styles['price-sub']}>per month</span>
                                    <span className={styles['price-annual']}>or $99.99 billed yearly</span>
                                </div>
                                <ul>
                                    <li className={styles['check']}><b>No ads — nothing between you and your file</b></li>
                                    <li className={styles['check']}>4 GB file size limit</li>
                                    <li className={styles['check']}>Fastest file upload*</li>
                                    <li className={styles['check']}>4 hr/task process time</li>
                                    <li className={styles['check']}>25 Concurrent non-video tasks</li>
                                    <li className={styles['check']}>8 Concurrent video tasks</li>
                                    <li className={styles['check']}>400 video conversions per day</li>
                                    <li className={styles['check']}>24 hours of processing time per day**</li>
                                    <li className={styles['check']}>High compression encoders</li>
                                </ul>
                                <div className={styles['footnote']}>
                                    * Files upload in parallel chunks to the nearest edge server in our global network for the fastest available transfer speeds.
                                    <br />** Processing time is the CPU time our servers spend on your files — a typical video conversion uses 1–5 minutes. Daily allowances reset at midnight UTC.
                                </div>
                                <a className={`${styles['btn']} ${styles['btn-primary']}`} href="/product/patron_monthly">
                                    Start Pro
                                </a>
                            </div>
                        </div>
                    </div>
                </div>

                {/* FAQ Section */}
                <div className={`container mt-5 pt-5 pb-5 ${styles["content-section"]}`}>
                    <div className="text-center mb-5">
                        <h2 className={styles['section-title']}>Frequently Asked Questions</h2>
                    </div>

                    <div className="row justify-content-center">
                        <div className="col-md-5 mr-md-4 mb-4">
                            <h5 className={styles['qa-section']}>General & Privacy</h5>
                            <h6 className={styles['qa-question']}>Can I use this on multiple devices?</h6>
                            <p className={styles['qa-answer']}>You can use your account on up to 3 devices simultaneously.</p>

                            <h6 className={styles['qa-question']}>Why do you need my email?</h6>
                            <p className={styles['qa-answer']}>We need a valid email for account verification and login. It is also required for managing your subscription.</p>

                            <h6 className={styles['qa-question']}>What kind of support do you offer?</h6>
                            <p className={styles['qa-answer']}>XConvert is a SaaS platform. You'll receive all updates and bug fixes automatically. Paid users get immediate access to all new features.</p>

                            <h6 className={styles['qa-question']}>Who can access my files?</h6>
                            <p className={styles['qa-answer']}>Your connection is secured with TLS encryption. All files are automatically deleted a few hours after upload.</p>
                        </div>
                        <div className="col-md-5">
                            <h5 className={styles['qa-section']}>Payment & Billing</h5>
                            <h6 className={styles['qa-question']}>What are my payment options?</h6>
                            <p className={styles['qa-answer']}>We accept PayPal, Visa, MasterCard, American Express, Diners Club, JCB, Discover, and more.</p>

                            <h6 className={styles['qa-question']}>What is your cancellation and refund policy?</h6>
                            <p className={styles['qa-answer']}>You can cancel your subscription anytime via the User Portal. While we don't offer refunds, your access continues until the end of your billing cycle.</p>

                            <h6 className={styles['qa-question']}>Do you offer special pricing for nonprofits?</h6>
                            <p className={styles['qa-answer']}>Yes, please contact us at support@xconvert.com to learn about our special pricing.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }
}
